module.exports = __webpack_public_path__ + "img/shelter-upgraded.1bf5bce6.png";